export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
                <i className="ri-file-text-line text-2xl text-teal-600"></i>
              </div>
              <span className="text-2xl font-bold">ItsJustTax</span>
            </div>
            <p className="text-teal-50 leading-relaxed">
              Your trusted resource for US tax information, tools, and expert guidance.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Tax Resources</h4>
            <ul className="space-y-3">
              <li><a href="#calculators" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Tax Calculators</a></li>
              <li><a href="#forms" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Tax Forms</a></li>
              <li><a href="#state-resources" className="text-teal-50 hover:text-white transition-colors cursor-pointer">State Resources</a></li>
              <li><a href="#blog" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Tax Blog</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Popular Forms</h4>
            <ul className="space-y-3">
              <li><a href="#forms" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Form 1040</a></li>
              <li><a href="#forms" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Schedule C</a></li>
              <li><a href="#forms" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Form 1099-NEC</a></li>
              <li><a href="#forms" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Form W-2</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Connect</h4>
            <p className="text-teal-50 leading-relaxed">
              Stay informed with the latest tax updates, tips, and resources to help you navigate US tax requirements with confidence.
            </p>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-teal-50 text-sm">
            © 2025 ItsJustTax. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Terms of Service</a>
            <a href="https://aitaxforms.com" target="_blank" rel="noopener noreferrer" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Powered by AITaxForms.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
}